"use strict";

// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var _classCallCheck = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");
var _inherits = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _wrapNativeSuper = require("G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldError = void 0;
exports.isFieldError = isFieldError;
var errorNames = ["FieldValueInvalidError", "FieldListRangeError", "ForeignFieldError"];
var FieldError = /*#__PURE__*/function (_Error) {
  _inherits(FieldError, _Error);
  function FieldError(fieldOrOneof, message) {
    var _this;
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "FieldValueInvalidError";
    _classCallCheck(this, FieldError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FieldError).call(this, message));
    _this.name = name;
    _this.field = function () {
      return fieldOrOneof;
    };
    return _this;
  }
  return FieldError;
}(_wrapNativeSuper(Error));
exports.FieldError = FieldError;
function isFieldError(arg) {
  return arg instanceof Error && errorNames.includes(arg.name) && "field" in arg && typeof arg.field == "function";
}